define('Components/Comein/js/views/blocks/CartDeliveryDataView',[
    'backbone',
    'underscore',
    'app',
    'formatPrice',
    'template!Components/Comein/templates/blocks/cart-delivery-data',
],
function (
    Backbone,
    _,
    app,
    formatPrice,
    template
) {

        var parentView, cart, context;

    return Backbone.View.extend({
        initialize:function(options){
            var view = this;
            cart = options.cart;
            if(!cart.getStore()) return; // si on a pas de boutique on ne fait rien
            context = options.context;
            parentView = options.view;
            view.listenTo(cart, 'change:total_price_ttc change:cagnotte', this.render);
            view.render();
        },

        render: function() {
            if (!cart.useCagnotte()) return
            var view = this,
                icon = context !== 'footerCheckout'; // on affiche pas l'icone sur le footer panier
            view.$el.html(template({
                label: view.getLabel(),
                icon: icon
            }))
        },

        getLabel: function() {
            var cagnotteAmount = formatPrice((cart.getPriceTTC() - cart.getCagnotte()) * app.c('_COMEIN_RECUP_VALUE_', 5) / 100)
            return app.t(
                cart.isVAE()
                    ? "En passant cette commande, vous cagnotterez <strong>%s</strong> grâce à <strong>Come In</strong> <span class='icon-error'></span>"
                    : "En Click & Collect, grâce à cette commande vous pouvez cagnotter <strong>%s</strong> <span class='icon-error'></span>",
                'Cart',
                cagnotteAmount
            )
        }
    });
});
